import { createContext } from "react";
export const CustomThemeContext = 
  createContext ({ currentTheme: 'dark', setTheme: (name: string) => {}});